module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_maedori@2x-d91a6f2b642141bb0ebea7beb3e43b0a.webp";